const inFlight=new Map<string,Promise<unknown>>();

export async function coalesceRead<T>(key: string,load:()=>Promise<T>): Promise<T> {
  let pending=inFlight.get(key) as Promise<T>|undefined;
  if(!pending){
    pending=load();inFlight.set(key,pending);
    const current=pending;
    const remove=()=>{if(inFlight.get(key)===current)inFlight.delete(key);};
    pending.then(remove,remove);
  }
  const value=await pending;
  return typeof structuredClone==='function' ? structuredClone(value) : JSON.parse(JSON.stringify(value));
}

export function createWorkLimiter(limit: number) {
  let active=0;const waiting:Array<()=>void>=[];
  return async function limited<T>(operation:()=>Promise<T>): Promise<T>{
    if(active>=limit)await new Promise<void>(resolve=>waiting.push(resolve));
    else active++;
    try{return await operation();}
    finally{const next=waiting.shift();if(next)next();else active--;}
  };
}

interface AssetEntry {expiresAt:number;promise:Promise<Blob>;bytes:number}
const assets=new Map<string,AssetEntry>();
const assetWork=createWorkLimiter(4);
const maxBytes=16*1024*1024;

export function clearAssetCache(): void {assets.clear();}

export function cachedAsset(key: string,load:(signal:AbortSignal)=>Promise<Blob>): Promise<Blob>{
  for(const [id,item]of assets)if(item.expiresAt<Date.now())assets.delete(id);
  const existing=assets.get(key);if(existing)return existing.promise;
  const entry:AssetEntry={expiresAt:Infinity,bytes:0,promise:assetWork(async()=>{
    const controller=new AbortController();
    const timeout=setTimeout(()=>controller.abort(),15_000);
    try{return await abortableRead(load(controller.signal),controller.signal);}
    finally{clearTimeout(timeout);}
  })};
  assets.set(key,entry);
  entry.promise.then(blob=>{
    entry.expiresAt=Date.now()+60_000;entry.bytes=blob.size;
    if(blob.size>maxBytes){if(assets.get(key)===entry)assets.delete(key);return;}
    let bytes=[...assets.values()].reduce((sum,item)=>sum+item.bytes,0);
    for(const [id,item]of assets){if(assets.size<=128&&bytes<=maxBytes)break;if(item.expiresAt!==Infinity){assets.delete(id);bytes-=item.bytes;}}
  },()=>{entry.expiresAt=Date.now()+10_000;});
  return entry.promise;
}

// Consumers may leave while another thumbnail still needs the shared request.
export function abortableRead<T>(pending:Promise<T>,signal:AbortSignal): Promise<T>{
  if(signal.aborted)return Promise.reject(new DOMException('Aborted','AbortError'));
  return new Promise((resolve,reject)=>{
    const abort=()=>reject(new DOMException('Aborted','AbortError'));
    signal.addEventListener('abort',abort,{once:true});
    pending.then(value=>{signal.removeEventListener('abort',abort);resolve(value);},error=>{signal.removeEventListener('abort',abort);reject(error);});
  });
}
